import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import styled from 'styled-components';

const Styles = styled.div`
  .social-float-button {
    left: 25px;
    right: unset !important;
    height: 44px !important;
    width: 44px !important;
    background-color: #25d366;
  }

  .social-float-button svg {
    fill: currentColor;
    height: 30px !important;
    width: 30px !important;
    color: #fff;
    margin: 6px 7px !important;
  }

  .social-float-button:hover,
  .social-float-button.active {
    background-color: #25d366 !important;
    box-shadow: 0 5px 24px rgb(0 0 0 / 30%);
  }

  #whatsapp-float-button {
    bottom: 80px;
    animation: fadeInBottom 4.3s;
  }

  #whatsapp-float-button-admin {
    bottom: 80px;
    animation:
      fadeInBottom 4.3s,
      4.3s animation-waggle 5s 5;
  }

  @keyframes animation-waggle {
    0% {
      transform: none;
    }
    10% {
      transform: rotateZ(-20deg) scale(1.3);
    }
    13% {
      transform: rotateZ(25deg) scale(1.3);
    }
    15% {
      transform: rotateZ(-20deg) scale(1.3);
    }
    17% {
      transform: rotateZ(15deg) scale(1.3);
    }
    20% {
      transform: rotateZ(-10deg) scale(1.3);
    }
    22% {
      transform: rotateZ(0) scale(1.3);
    }
    100%,
    24% {
      transform: rotateZ(0) scale(1);
    }
  }

  @keyframes fadeInBottom {
    0% {
      opacity: 0;
    }
    95% {
      opacity: 0;
      transform: translateY(100%);
    }
    100% {
      opacity: 1;
      display: block;
    }
  }
`;

const WhatsappFloatingButton: React.FC<{
  isAdmin: boolean;
}> = ({ isAdmin }) => {
  return (
    <Styles>
      <a
        href="https://api.whatsapp.com/send?phone=85269000755"
        target="_blank"
        rel="noopener noreferrer"
        className="float-button social-float-button"
        id={isAdmin ? 'whatsapp-float-button-admin' : 'whatsapp-float-button'}
      >
        <FaWhatsapp />
      </a>
    </Styles>
  );
};

export default WhatsappFloatingButton;
